import { useCallback, useMemo } from "react";
import { Task } from "@common/types/task";
import { createScheduleRuleSuggestedReviewDefaultView } from "@common/types/views/scheduleReviewViews";
import { RuleSuggestedReviewTaskActionBar } from "./RuleSuggestedReviewTaskActionBar";
import {
    ScheduleReviewFooterOptions,
    ScheduleReviewTransactionsTaskBody,
} from "./ScheduleReviewTransactionsTaskBody";

interface RuleSuggestedReviewTaskBodyProps {
    selectedTask: Task;
}

export const RuleSuggestedReviewTaskBody = ({
    selectedTask,
}: RuleSuggestedReviewTaskBodyProps) => {
    const entityId = selectedTask.entityIds?.[0] ?? null;
    const initialFilters = useMemo(
        () => selectedTask.view?.filters ?? {},
        [selectedTask.view?.filters],
    );
    const renderFooter = useCallback(
        (options?: ScheduleReviewFooterOptions) => (
            <RuleSuggestedReviewTaskActionBar
                entityId={entityId}
                initialFilters={initialFilters}
                scrollTo={options?.scrollTo}
            />
        ),
        [entityId, initialFilters],
    );

    return (
        <ScheduleReviewTransactionsTaskBody
            selectedTask={selectedTask}
            buildDefaultView={createScheduleRuleSuggestedReviewDefaultView}
            emptyText="No rule-suggested schedules left to review"
            renderFooter={renderFooter}
        />
    );
};
